<template>
<div class="support">
	<div class="page-title">ТЕХПОДДЕРЖКА</div>
	<div class="support__head">
		<button v-if="isMob" class="btn support__head-item" @click="showChats = true">
			<svg class="btn__icon"><use href="#svg-icon-chat"></use></svg>
		</button>
		<button class="btn support__head-item" @click="showCreateModal = true">Создать тикет</button>
		<button v-if="thread?.can_close && !thread.closed_at" class="btn" @click="closeThread">Закрыть тикет</button>
		<button v-if="thread?.can_rate && thread.closed_at" class="btn support__head-item" @click="openRateModal">Оценить тикет</button>
		<div v-if="thread?.rating" class="support__head-item">
			<div class="support__rate-text">Ваш оценка тикета</div>
			<div class="support__rate-stars support__rate-stars--sm">
				<svg v-for="star in 5" class="support__rate-star disabled" :class="{full: thread.rating >= star}"><use href="#svg-icon-star"></use></svg>
			</div>
		</div>
	</div>
	<div class="support__layout">
		<div class="support__main">
			<div class="support__view no-scrollbar" ref="list">
				<Loader class="support__loader" v-if="loading" :loading="loading" static/>
				<div v-else-if="!messages?.length" class="support__plug">Сообщений нет</div>
				<div v-else class="support__messages" ref="messages">
					<div v-for="message in messages" class="support__message" :class="{self: message.user.id === user.id}">
						<div class="support__message-main">
							<span v-if="message.type === 'message'" class="support__message-text" v-html="message.content"></span>
							<img v-if="message.type === 'attachment' && message.content.is_media"
								 :src="message.content.preview_url || message.content.url"
								 @click="modalMedia = message"
								 alt=""
								 class="support__message-img"
							>
							<a v-if="message.type === 'attachment' && !message.content.is_media" :href="message.content.url" target="_blank" class="support__message-doc">
								<svg class="support__message-doc-icon"><use href="#svg-icon-doc"></use></svg>
							</a>
						</div>
						<div class="support__message-footer">
							<small class="support__message-time">{{message.human_created_at}}</small>
							<svg v-if="message.user.id === user.id" class="support__message-check"><use :href="message.is_unread ? '#svg-icon-chat-check' : '#svg-icon-chat-check-double'"></use></svg>
						</div>
					</div>
				</div>
			</div>
			<div class="support__input-area">
				<label v-if="thread && !thread.closed_at" class="support__send-btn" @click="sendMessage">
					<input class="support__send-btn-input" type="file" @change="handlerAttach($event)">
					<svg class="support__send-btn-icon"><use href="#svg-icon-attach"></use></svg>
				</label>
				<input class="support__input"
					   v-model="value"
					   @keydown.enter="sendMessage"
					   :placeholder="inputPlaceholder"
					   :disabled="!thread || (thread && thread.closed_at)"
				>
				<button v-if="value" class="support__send-btn" @click="sendMessage">
					<svg class="support__send-btn-icon"><use href="#svg-icon-send"></use></svg>
				</button>

			</div>
		</div>
		<div v-if="!isMob" class="support__aside">
			<div class="support__chats-wrap no-scrollbar">
				<div class="support__chats">
					<div v-for="chat in chats" class="support__chat" :class="{active: thread && thread.id === chat.id}" @click="setActiveThread(chat)">
						<div class="support__chat-head">
							<div class="support__chat-title">{{chat.title}}</div>
							<div class="support__chat-time">{{getFormattedTime(chat.created_at)}}</div>
							<svg class="support__chat-check"><use :href="chat.is_unread ? '#svg-icon-chat-check' : '#svg-icon-chat-check-double'"></use></svg>
						</div>
						<div class="support__chat-body">
							<div class="support__chat-msg">{{chat.last_message.content}}</div>
							<div class="support__chat-status">{{chat.closed_at ? 'закрыт' : ''}}</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<teleport to="body">
		<Modal class="support__modal" :openState="showCreateModal" @close="showCreateModal = false" :data="{title: 'Новый тикет'}">
			<div class="fields__item">
				<input autocomplete="off" class="field-input__input" placeholder="Введите тему"
					   type="text" v-model="newThread.title">
			</div>
			<div class="fields__item">
				<input autocomplete="off" class="field-input__input" placeholder="Описание"
					   type="text" v-model="newThread.text">
			</div>
			<div class="fields__item">
				<button class="btn btn--block" @click="createThread" :disabled="!newThread.title || !newThread.text">
					Создать тикет
				</button>
			</div>
		</Modal>
		<Modal class="support__modal" :openState="!!modalMedia" @close="modalMedia = null">
			<img :src="modalMedia?.content?.url" alt="" class="support__modal-img">
		</Modal>
		<Modal class="support__modal" :openState="showRateModal" @close="showRateModal = false" :data="{title: 'Оценить тикет'}">
			<div v-if="thread?.rate" class="fields__items">
				<div class="fields__item text-center">
					<div class="support__rate-stars">
						<svg v-for="star in 5"
							 class="support__rate-star"
							 :class="{full: thread.rate.value >= star}"
							 @click="thread.rate.value = star"
						>
							<use href="#svg-icon-star"></use>
						</svg>
					</div>
				</div>
				<div class="fields__item">
					<input autocomplete="off" class="field-input__input" placeholder="Комментарий"
						   type="text" v-model="thread.rate.comment">
				</div>
				<div class="fields__item">
					<button class="btn btn--block" @click="rateThread" :disabled="!thread.rate.value">
						Оценить тикет
					</button>
				</div>
			</div>
		</Modal>
		<Modal class="support__modal" :openState="!!attach" @close="attach = null" :data="{title: 'Отправить файл?'}">
			<div class="fields__item">
				{{attach?.name}}
			</div>
			<div class="fields__item fields__row">
				<div class="fields__item">
					<button class="btn btn--block btn--red" @click="attach = null">
						Отмена
					</button>
				</div>
				<div class="fields__item">
					<button class="btn btn--block" @click="sendFile">
						Отправить
					</button>
				</div>
			</div>
		</Modal>
		<Modal class="support__chats-modal" :openState="showChats && isMob" @close="showChats = false">
			<div class="support__chats">
				<div v-for="chat in chats" class="support__chat" :class="{active: thread && thread.id === chat.id}" @click="setActiveThread(chat)">
					<div class="support__chat-head">
						<div class="support__chat-title">{{chat.title}}</div>
						<div class="support__chat-time">{{getFormattedTime(chat.created_at)}}</div>
						<svg class="support__chat-check"><use :href="chat.is_unread ? '#svg-icon-chat-check' : '#svg-icon-chat-check-double'"></use></svg>
					</div>
					<div class="support__chat-body">
						<div class="support__chat-msg">{{chat.last_message.content}}</div>
						<div class="support__chat-status">{{chat.closed_at ? 'закрыт' : ''}}</div>
					</div>
				</div>
			</div>
		</Modal>
	</teleport>
</div>

</template>

<script>

import { mapState } from 'pinia';
import { useUserStore } from '../../stores/User';
import Loader from "../../components/blocks/Loader.vue";
import Modal from "../../components/blocks/Modal.vue";
import breakpointsMixin from "../../mixins/breakpoints-mixin.vue";

export default {
	mixins: [
		breakpointsMixin
	],

	components: {
		Modal,
		Loader
	},

	data() {
		return {
			value: null,
			chats: [],
			messages: [],
			thread: null,
			loading: true,
			showCreateModal: false,
			newThread: {
				title: '',
				text: ''
			},
			modalMedia: null,
			showRateModal: false,
			attach: null,
			formData: null,
			showChats: false
		}
	},

	computed: {
		...mapState(useUserStore, ['user']),

		inputPlaceholder() {
			return this.thread ? (this.thread.closed_at ? 'Тикет закрыт' : 'Введите сообщение') : 'Выберите тикет';
		}
	},

	watch: {
		messages: {
			deep: true,
			handler() {
				this.scrollToEnd();
			}
		}
	},

	mounted() {
		this.getThreads(true);
	},

	methods: {
		getThreads(setActive = false) {
			this.$root.axios.get('/api/support/threads')
				.then(res => {
					if (res.error) {
						this.$toast.success(res.error)
					} else {
						console.log('getThreads', res.data)
						this.chats = res.data.data;
						if(setActive && window.location.hash) {
							let thread = this.chats.find(item => item.id == window.location.hash.replace('#', ''))
							if (thread) {
								this.setActiveThread(thread)
							}
						}
					}
				}).catch(e => {}).finally(() => this.loading = false)
		},

		createThread() {
			this.$root.axios.post('/api/support/thread', {
				title: this.newThread.title,
				message: this.newThread.text
			}).then(res => {
				if (res.error) {
					this.error = res.error
				} else {
					this.error = null;
					this.thread = res.data.data;
					this.newThread = {title: '', text: ''};
					this.showCreateModal = false;
					this.setActiveThread(this.thread);
				}
				console.log(res);
			}).catch(e => {})
		},

		getThread() {
			this.$root.axios.get('/api/support/thread', {
				params: {
					thread_id: this.thread.id
				}
			}).then(res => {
				if (res.error) {
					this.error = res.error
				} else {
					this.messages = res.data.data.messages;
					this.error = null;
					this.readThread();
				}
				console.log('getThread', res);
			}).catch(e => {}).finally(() => this.loading = false)
		},

		readThread() {
			this.$root.axios.post('/api/support/thread/read', {
				thread_id: this.thread.id
			})
		},

		closeThread() {
			this.$root.axios.post('/api/support/thread/close', {
				thread_id: this.thread.id
			}).then(this.getThreads)
		},

		rateThread() {
			this.$root.axios.post('/api/support/thread/rate', {
				thread_id: this.thread.id,
				rating: this.thread.rate.value,
				comment: this.thread.rate.comment,
			}).then(res => {
				if (res.success) this.showRateModal = false;
			})
		},

		sendMessage() {
			if (!this.value && this.thread) return

			this.$root.axios.post('/api/support/message', {
				thread_id: this.thread.id,
				message: this.value
			}).then(res => {
				if (res.data.success) {
					this.appendMessage(res.data.data)
				}
				console.log('sendMessage', res);
			})
			this.value = null;
		},

		scrollToEnd() {
			console.log('scrollToEnd', this.$refs);
			setTimeout(() => this.$refs.list.scrollTop = this.$refs.messages?.scrollHeight || 0, 333);
		},

		setActiveThread(thread) {
			this.loading = true;
			this.showChats = false;
			this.thread = thread;
			window.location.hash = thread.id;
			this.getThread();
		},

		appendMessage(message) {
			console.log('appendMessage', message)
			if (this.thread.id === message.thread_id) {
				this.messages.push(message);
			}
			this.getThreads()
		},
		getFormattedTime(time) {
			return time ? `${new Date(time).getHours()}:${new Date(time).getMinutes() < 10 ? '0' : ''}${new Date(time).getMinutes() || '0'}` : null;
		},

		openRateModal() {
			if (this.thread) {
				this.thread.rate = {
					comment: null,
					value: null
				}
				this.showRateModal = true;
			}
		},

		handlerAttach(e) {
			console.log('handlerAttach', e);
			this.formData = new FormData();
			this.formData.append('thread_id', this.thread.id)
			this.formData.append('attachment', e.target.files[0])
			this.attach = e.target.files[0];
		},

		sendFile() {
			console.log('sendFile', this.attach)
			this.$root.axios.post('/api/support/attachment', this.formData, {
				headers: {
					'Content-Type': 'multipart/form-data'
				}
			}).then(res => {})
			.catch(e => {
				this.$toast.error(e.response.data.error)
			}).finally(() => this.attach = null)
		}
	},

	sockets: {
		'support.thread': function(data) {
			this.getThreads();
			console.log('support.thread', data);
		},
		'support.message': function(data) {
			this.appendMessage(data);
			console.log('support.message', data);
		}
	}
}

</script>